var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 18,
    viewBox: "0 0 142 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3741 18H28.6019V7.30645L22.9436 13.0403L17.2853 7.30645V18H13.5131V0H15.5185L22.9913 7.57258L30.3687 0H32.3741V18Z",
    fill: "#12295D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74091 8.08557H0L9.74091 17.9565V8.08557Z",
    fill: "#F23A1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.575 17.9471H37.3405V0H53.8467V3.69788H41.1272V6.65619H49.4774V10.2555H41.1272V14.3478H54.575V17.9471Z",
    fill: "#12295D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8604 17.9471H73.6435L68.9903 10.6402H62.8346V17.9471H59.1024V0.0965576H70.9292C72.6741 0.0965576 74.0313 0.537917 75.0976 1.3716C76.2609 2.30336 76.8425 3.62744 76.8425 5.34384C76.8425 6.5208 76.5032 7.55064 75.8731 8.4824C75.1945 9.41416 74.3221 10.0517 73.2073 10.444L77.8604 17.9471ZM73.0134 5.34384C73.0134 4.85344 72.868 4.46112 72.5287 4.16688C72.1894 3.92168 71.6077 3.77456 70.8807 3.77456H62.8346V7.06024H70.8807C71.6562 7.06024 72.1894 6.91312 72.5287 6.61888C72.868 6.17752 73.0134 5.7852 73.0134 5.34384Z",
    fill: "#12295D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.391 17.9471H95.9746L89.422 9.02184L86.7525 11.3267V17.9471H82.9666V0.0965576H86.7525V6.766L94.567 0.0965576H99.809L92.1401 6.66792L100.391 17.9471Z",
    fill: "#12295D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 17.9471H104.779V0H108.56V14.3478H120.68V17.9471Z",
    fill: "#12295D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.995 17.9471H124.76V0H141.266V3.69788H128.498V6.65619H136.848V10.2555H128.498V14.3478H141.995V17.9471Z",
    fill: "#12295D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/Logo_Dark.a3909b6a495877d7408789b7ca2a40b4.svg";
export { ForwardRef as ReactComponent };